import * as tslib_1 from "tslib";
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { SocketGateway } from 'src/app/network/gateway/socket.gateway';
import * as isEqual from 'lodash.isequal';
import { distinctUntilChanged, map, withLatestFrom } from 'rxjs/operators';
import { PageDirection } from 'src/models/constants';
import * as Whitelist from 'src/models/Whitelist';
import { WhitelistUiDispatchers } from './whitelistMainUI.dispatchers';
export class WhitelistUIEffects {
    constructor(actions$, _socketGateway, _whitelistUiDispatchers, _store) {
        this.actions$ = actions$;
        this._socketGateway = _socketGateway;
        this._whitelistUiDispatchers = _whitelistUiDispatchers;
        this._store = _store;
        this.afterWhitelistResetPaging = this.actions$.pipe(ofType("UI_WHITELIST_RESET_PAGING" /* UI_WHITELIST_RESET_PAGING */), map((action) => {
            this._whitelistUiDispatchers.getNextWhitelistPage();
        }));
        this.getNextWhitelistPage = this.actions$.pipe(ofType("UI_GET_NEXT_WHITELIST_PAGE" /* UI_GET_NEXT_WHITELIST_PAGE */), withLatestFrom(this._store
            .select(state => state.whitelistUIReducer)
            .pipe(distinctUntilChanged(isEqual))), map(([val, whitelistUiState]) => {
            const action = val;
            const prevRequest = whitelistUiState.previousRequest;
            if (!(prevRequest.eop === whitelistUiState.eop &&
                PageDirection.NEXT === prevRequest.direction &&
                prevRequest.hash === whitelistUiState.hash)) {
                this._socketGateway.sendSocketMessage(new Whitelist.GetWhitelistMethod(null, 0, whitelistUiState.hash, whitelistUiState.eop, whitelistUiState.msisdn));
            }
            else {
                this._whitelistUiDispatchers.setStatusAsIdle();
            }
        }));
        this.getPrevWhitelistPage = this.actions$.pipe(ofType("UI_GET_PREV_WHITELIST_PAGE" /* UI_GET_PREV_WHITELIST_PAGE */), withLatestFrom(this._store
            .select(state => state.whitelistUIReducer)
            .pipe(distinctUntilChanged(isEqual))), map(([val, whitelistUiState]) => {
            const action = val;
            const prevRequest = whitelistUiState.previousRequest;
            if (!(prevRequest.sop === whitelistUiState.sop &&
                PageDirection.PREV === prevRequest.direction &&
                prevRequest.hash === whitelistUiState.hash)) {
                this._socketGateway.sendSocketMessage(new Whitelist.GetWhitelistMethod(null, 1, whitelistUiState.hash, whitelistUiState.sop, whitelistUiState.msisdn));
            }
            else {
                this._whitelistUiDispatchers.setStatusAsIdle();
            }
        }));
        this.addUserToWhitelist = this.actions$.pipe(ofType("UI_ADD_USER_TO_WHITELIST" /* UI_ADD_USER_TO_WHITELIST */), map((action) => {
            this._socketGateway.sendSocketMessage(new Whitelist.AddUsersToWhitelist(action.chat_id, action.users));
        }));
        this.deleteUserFromWhitelist = this.actions$.pipe(ofType("UI_DELETE_USER_FROM_WHITELIST" /* UI_DELETE_USER_FROM_WHITELIST */), map((action) => {
            this._socketGateway.sendSocketMessage(new Whitelist.RemoveUserFromWhitelist(action.users, action.chat_id));
        }));
    }
}
tslib_1.__decorate([
    Effect({ dispatch: false }),
    tslib_1.__metadata("design:type", Object)
], WhitelistUIEffects.prototype, "afterWhitelistResetPaging", void 0);
tslib_1.__decorate([
    Effect({ dispatch: false }),
    tslib_1.__metadata("design:type", Object)
], WhitelistUIEffects.prototype, "getNextWhitelistPage", void 0);
tslib_1.__decorate([
    Effect({ dispatch: false }),
    tslib_1.__metadata("design:type", Object)
], WhitelistUIEffects.prototype, "getPrevWhitelistPage", void 0);
tslib_1.__decorate([
    Effect({ dispatch: false }),
    tslib_1.__metadata("design:type", Object)
], WhitelistUIEffects.prototype, "addUserToWhitelist", void 0);
tslib_1.__decorate([
    Effect({ dispatch: false }),
    tslib_1.__metadata("design:type", Object)
], WhitelistUIEffects.prototype, "deleteUserFromWhitelist", void 0);
